import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

const {
	colors,
	common: { borderRadius },
	spacing: { sm, md, lg },
} = THEME;

export const styleSheet = StyleSheet.create({
	contactWrapper: {
		padding: lg,
	},
	pageContainer: {
		paddingTop: md,
	},
	autoReply: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
	},
	autoReplyMessageTextField: {
		height: 120,
		resize: 'none',
	},
	container: {
		width: '100%',
	},
	autoReplyContainer: {
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	autoReplyToggles: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	drawerColumn: {
		width: 400,
		maxWidth: 400,
		padding: lg,
	},
	footer: {
		display: 'flex',
		paddingTop: 15,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	manageButton: {
		fontSize: 12,
		paddingLeft: 10,
	},

	modal: {
		width: 400,
	},
	modalTitle: {
		color: brandPrimary,
		height: 20,
		paddingBottom: 10,
	},
	modalContent: {
		paddingTop: THEME.spacing.lg,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	wrapper: {
		marginTop: sm,
		alignItems: 'center',
		background: colors.background.light,
		borderRadius,
		boxSizing: 'border-box',
		width: '100%',
		marginBottom: 8,
		flex: 1,
		minHeight: 0,
	},
});
